import { API_URL } from "../utils/AppApiUrl";
import { post } from "../utils/httpClient-methods";
import tokenHttpClient from "../utils/httpClient";
import { BASE_URL_SPARE_LIST } from "../utils/AppApiUrl";

const SpareDetailsById = async (requestBody) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL_SPARE_LIST}${API_URL.spareDetailsById}`,
      requestBody
    );

    if (response.status === 200) {
      return response;
    } else {
      return {};
    }
  } catch (err) {
    console.log("error", err);
    throw err;
  }
};

export default SpareDetailsById;
